import useSWR from 'swr';
import { analyticsService, FailureDimension, FailureMatrixResponse } from '../services/analyticsService';

interface UseFailureMatrixReturn {
  matrix: FailureMatrixResponse | undefined;
  loading: boolean;
  error: Error | undefined;
}

// Whole period, no year: the "Failures by family" tab does not follow the year selector.
export const useFailureMatrix = (dimension: FailureDimension): UseFailureMatrixReturn => {
  const { data, error, isLoading } = useSWR<FailureMatrixResponse, Error>(
    `/api/v1/analytics/service/failures/matrix?dimension=${dimension}`,
    () => analyticsService.getFailureMatrix(dimension),
    { revalidateOnFocus: false, revalidateOnReconnect: true, dedupingInterval: 5000 }
  );

  return { matrix: data, loading: isLoading, error };
};
